import { GET_FINANCIAL_GROUP_BY_ID, PRICE_TO_PAY_DRIVER } from "../../routes";
import customAxios from "../../customAxios";

async function findFinancialGroup({
  financialGroupId,
}: {
  financialGroupId: string;
}) {
  try {
    const result = (
      await customAxios.get(`${GET_FINANCIAL_GROUP_BY_ID}/${financialGroupId}`)
    ).data;
    return result;
    // handle the response
  } catch (error) {
    console.log(error);
    return false;
  }
}

export default findFinancialGroup;
